import { useMutation } from "@tanstack/react-query";
import { firstErrorMessage } from "../../../helpers/apiErrors";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { REACT_APP_BASE_URL } from "src/helpers/constants";
type UserData = {
  email: string;
};

export const useForgotPassword = () => {
  const initialValues = {
    email: "",
  };
  const navigate = useNavigate();

  const resetPassword = async (userData: UserData) => {
    try {
      // Convert email to lowercase before making API call
      const apiData = {
        ...userData,
        email: userData.email.toLowerCase()
      };
      
      const response = await fetch(`${REACT_APP_BASE_URL}/auth/user/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(apiData),
      });

      const data = await response.json();

      if (!response.ok) {
        let errorMessage = "An unknown error occurred";
        Object.keys(data).forEach((propertyName) => {
          if (Array.isArray(data[propertyName])) {
            errorMessage = firstErrorMessage(data[propertyName]);
            toast.error(errorMessage);
          }
        });
        throw new Error("Password reset failed");
      }

      return data;
    } catch (error) {
      throw error;
    }
  };

  const ResetPassword = useMutation({
    mutationFn: resetPassword,
    mutationKey: ["Reset password"],
    onSuccess(data) {
      toast.success(data.message);
      navigate("/reset-password");
    },
    onError(error) {
      toast.error(error.message);
    },
  });

  const handleSubmit = async (
    values: { email: string },
    { setSubmitting }: { setSubmitting: (isSubmitting: boolean) => void },
  ) => {
    try {
      setSubmitting(true);
      await ResetPassword.mutateAsync(values);
    } catch {
    } finally {
      setSubmitting(false);
    }
  };

  return { handleSubmit, initialValues };
};
